import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { api } from './lib/api';
import { initErrorReporter } from './lib/errorReporter';
import { ErrorBoundary } from './components/ErrorBoundary';
import { App } from './App';
import './index.css';

initErrorReporter();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
    },
  },
});

const trpcClient = api.createClient({
  links: [
    httpBatchLink({
      url: '/api',
      headers: async () => {
        const { getSessionId } = await import('./lib/session');
        return { 'x-socket-session-id': getSessionId() };
      },
    }),
  ],
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <api.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </api.Provider>
    </ErrorBoundary>
  </React.StrictMode>,
);
